export class  TextPreparator {
  static prepare = (rawText: string) => {
    let result = String(rawText);

    // Проверка наличия скриптов и их удаление
    let start = result.indexOf("<script");
    while (start !== -1) {
      const end = result.indexOf("</script");
      result = result.slice(0,start) + result.slice(end+9)
      start = result.indexOf("<script");
    }

    // Проверка наличия ссылок и их удаление
    start = result.indexOf("<a");
    while (start !== -1) {
      const end = result.indexOf("</a");
      result = result.slice(0,start) + result.slice(end+4)
      start = result.indexOf("<a");
    }

    // Если текст записан в старом формате(без тегов), то он оборачивается в <p>
    if (result.indexOf('<p>') === -1) {
      result = "<p>"+result+"</p>";
    }

    return result;
  }
}